import React from 'react';

// Grid de mini-stats (patrón ②a del detalle): label arriba, valor abajo, sub opcional.
// stat: {key, label, value, tone: 'critic'|'bad'|'good'|null, sub}. Los stats sin valor
// se omiten (nunca "(vacío)" en un stat). `tone` colorea el VALOR — usarlo solo cuando el
// evento trae un level semántico; los deltas sin level van sin tone (neutros).
export function StatGrid({stats}) {
    const visible = (stats || []).filter(s => s && s.value !== null && s.value !== undefined && s.value !== '');
    if (!visible.length) return null;
    return (
        // Las columnas se resuelven en CSS con auto-fit sobre el ANCHO DEL CONTENEDOR. No usar
        // el grid de Bootstrap acá: sus breakpoints miden el VIEWPORT, así que en un monitor
        // ancho forzaba 4 columnas aunque la caja midiera 250px (la bitácora del Panel) y los
        // labels se partían a la mitad de una palabra.
        <div className="ald-stats">
            {visible.map(stat => (
                <div className="ald-stat" key={stat.key || stat.label}>
                    <span className="ald-stat-label">{stat.label}</span>
                    <span className={`ald-stat-value${stat.tone ? ` -${stat.tone}` : ''}`}>{stat.value}</span>
                    {stat.sub ? <span className="ald-stat-sub">{stat.sub}</span> : null}
                </div>
            ))}
        </div>
    );
}
